<template>
	<div class="bg-cyan py-5">
		<div class="container">
			<div class="row">
				<div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 h1 text-white">
					Mira los saludos de bienvienda de los y las <b>Jefes/as de Carrera</b>
				</div>
				<div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex align-items-center">
					<link-to :to="{name: 'jefes-carrera'}" a-class="btn btn-lg d-block w-100 bg-white text-cyan rounded-pill">
						<b>Ir a Saludos</b>
					</link-to>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: "banda-ver-saludos",
	computed: {}
}
</script>